import React, { useEffect, useState } from 'react';
import { Package, BarChart2, TrendingUp, Tag } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import api from '../../services/api';

export default function DashboardPage() {
  const { user }   = useAuth();
  const navigate   = useNavigate();
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      api.get('/school-portal/orders'),
      api.get('/school-portal/redemption'),
    ]).then(([ordersRes, rRes]) => {
      const orders  = ordersRes.data.data;
      const codes   = rRes.data.data || [];
      const total   = codes.length;
      const login1  = codes.filter(c => c.stdOne).length;
      const login2  = codes.filter(c => c.stdTwo).length;
      const orderGroups = (orders.batches?.length || 0) + (orders.printCodes?.length || 0) + (orders.legacy?.length || 0);
      setStats({ total, login1, login2, orderGroups, notRedeemed: total - login1 });
    }).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const hour     = new Date().getHours();
  const greeting = hour < 12 ? 'Good morning' : hour < 17 ? 'Good afternoon' : 'Good evening';

  const cards = [
    { label: 'Total Orders',      value: stats?.orderGroups  ?? '—', icon: Package,   color: '#C84B0F', bg: '#FEF3EE', border: '#FDCFB5', to: '/orders'     },
    { label: 'Total Codes',       value: stats?.total        ?? '—', icon: Tag,       color: '#1D4ED8', bg: '#EEF2FF', border: '#BFDBFE', to: '/redemption' },
    { label: 'Login 1 Redeemed',  value: stats?.login1       ?? '—', icon: BarChart2, color: '#15803D', bg: '#F0FDF4', border: '#BBF7D0', to: '/redemption' },
    { label: 'Login 2 Redeemed',  value: stats?.login2       ?? '—', icon: TrendingUp,color: '#0F766E', bg: '#F0FDFA', border: '#99F6E4', to: '/adoption'   },
  ];

  return (
    <div>
      <div style={{ marginBottom: 24 }}>
        <h1 style={{ fontSize: 24, fontWeight: 800, color: '#1C0A00', margin: '0 0 4px' }}>{greeting}, {user?.name?.split(' ')[0]} 👋</h1>
        <p style={{ fontSize: 13, color: '#9CA3AF', margin: 0 }}>{user?.school_name} · Overview</p>
      </div>

      {loading ? (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 60, gap: 12, color: '#9CA3AF' }}>
          <div className="loader" /> Loading…
        </div>
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: 16, marginBottom: 28 }}>
          {cards.map(c => (
            <div key={c.label} onClick={() => navigate(c.to)}
              style={{ background: c.bg, border: `1px solid ${c.border}`, borderRadius: 14, padding: '18px 20px', cursor: 'pointer', transition: 'box-shadow 0.15s', boxShadow: '0 1px 4px rgba(200,75,15,0.06)' }}
              onMouseEnter={e => e.currentTarget.style.boxShadow = '0 4px 16px rgba(200,75,15,0.12)'}
              onMouseLeave={e => e.currentTarget.style.boxShadow = '0 1px 4px rgba(200,75,15,0.06)'}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 10 }}>
                <c.icon size={16} color={c.color} />
                <span style={{ fontSize: 11, fontWeight: 700, color: c.color, textTransform: 'uppercase', letterSpacing: '0.06em', opacity: 0.8 }}>{c.label}</span>
              </div>
              <div style={{ fontSize: 30, fontWeight: 800, color: c.color, fontVariantNumeric: 'tabular-nums' }}>{typeof c.value === 'number' ? c.value.toLocaleString('en-IN') : c.value}</div>
            </div>
          ))}
        </div>
      )}

      {/* Quick links */}
      <div className="card" style={{ padding: '18px 20px' }}>
        <div style={{ fontSize: 14, fontWeight: 700, color: '#1C0A00', marginBottom: 14 }}>Quick Access</div>
        <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
          {[
            { label: '📦 View Orders',         to: '/orders'     },
            { label: '📊 Redemption Report',   to: '/redemption' },
            { label: '📈 Adoption Trends',     to: '/adoption'   },
          ].map(l => (
            <button key={l.to} onClick={() => navigate(l.to)}
              style={{ padding: '9px 16px', border: '1px solid #F0DCC8', borderRadius: 9, background: '#FFF8F4', color: '#C84B0F', fontSize: 13, fontWeight: 600, cursor: 'pointer' }}>
              {l.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
